import React, { Fragment } from 'react';
import { Routes, Route } from 'react-router-dom';
import ReduxToastr from "react-redux-toastr";
// CSS imports
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import "rc-time-picker/assets/index.css";
// Route imports
import * as R from './common/routes';
// Authentication imports
import Login from './pages/Auth/Login/Login';
import Registration from "./pages/Auth/Registration/Registration";
import Password from "./pages/Auth/Password/Password";
// Billing imports
import BillingPlans from "./pages/Billing/Plans/BillingPlans";
import BillingPayNow from "./pages/Billing/PayNow/BillingPayNow";
import BillingInvoice from "./pages/Billing/Invioce/BillingInvoice";
import BillingPaymentResult from "./pages/Billing/PaymentResult/BillingPaymentResult";
// Pages imports
import AboutDarts from './pages/About/Darts/AboutDarts';
import DartsScoring from './pages/Darts/Scoring/DartsScoring';
// Screens imports
import Main from "./pages/Main/Main";
import DartBoardV1 from './screens/DartBoard/ClassicDartBoard/DartBoard';
import DartBoard from './components/Darts/Board/DartBoard';
import MatchContainer from './screens/MatchContainer/MatchContainer';
import {Statistics} from './screens/Statistics/Statistics'
import GameScores from './screens/DartBoard/components/GameScores/GameScores';
import {DeniedPage} from './screens/Errors/Denied';
import LiveScorePage from './screens/LiveScorePage/LiveScorePage';
import DartMatchStatsTable from './screens/DartMatchStatsTable/DartMatchStatsTable';
import { LeagueTablePage } from './screens/LeagueTablePage/LeagueTablePage';
import { ActiveGameScorePage } from './screens/ScoreboardPage/ActiveGameScorePage';
import ShootOutDartBoard from "./screens/DartBoard/ShootOutDartBoard/ShootOutDartBoard";
import {ShootOutActiveGameScorePage} from "./screens/ShootOutScoreBoardPage";
import ShootOutMatchStats from "./screens/ShootOutMatchStatsTable/ShootOutMatchStatsTable";
import PreMatchPage from "./screens/PreMatchPage/PreMatchPage";
import PostMatchPage from "./screens/PostMatchPage/PostMatchPage";
import StaticStatistic from "./screens/PreMatchPage/StaticStatistic/StaticStatistic";
import DailyResults from "./screens/DailyResults/DailyResults";
import DartsEventManager from "./pages/Darts/EventManager/DartsEventManager";
import SendEmailForm from './screens/SendEmailForm/SendEmailForm';

import EmptyPage from './pages/EmptyPage';
import CmsLayout from './pages/Cms/CmsLayout';
import DartsPlayersCRUD from './pages/Darts/Players/DartsPlayersCRUD';
import DartsGamesCRUD from './pages/Darts/Games/DartsGamesCRUD';

import CompetitionsCRUD from './pages/Competitions/CompetitionsCRUD';
import TournamentsCRUD from './pages/Tournaments/TournamentsCRUD';
import ClientsCRUD from './pages/Access/Clients/ClientsCRUD';
import UsersCRUD from './pages/Access/Users/UsersCRUD';
import ListenersCRUD from './pages/Access/Listeners/ListenersCRUD';
import RolesList from './pages/Access/Roles/RolesList';

import LoggingExceptions from "./pages/Logging/Exceptions/LoggingExceptions";
import LoggingConnections from "./pages/Logging/Connections/LoggingConnections";
import LoggingMessages from "./pages/Logging/Messages/LoggingMessages";

const AppContainer = () => {
    //const dispatch = useAppDispatch();
    //useEffect(() => {
    //    dispatch(getOnStartUp());
    //}, [dispatch])

    return (
        <Fragment>
            <Routes>
                <Route path={R.MAIN} element={<Main />} />
                <Route path={R.DARTS_EVENT_MANAGER} element={<DartsEventManager/>}/>
                <Route path={R.DARTS_SCORING_values} element={<DartsScoring />} />
                <Route path={R.DARTS_LIVESCORE} element={<LiveScorePage />} />

                {/*<Route path={R.DARTS_game} element={<MatchContainer><DartBoardV1 /></MatchContainer>} />*/}
                {/*<Route path={R.DARTS_STANDALONE_game} element={<MatchContainer><DartBoardV1 /></MatchContainer>} />*/}
                {/*<Route path={R.DARTS_SHOOTOUT_game} element={<MatchContainer><ShootOutDartBoard /></MatchContainer>} />*/}

                <Route path={R.CMS} element={<CmsLayout />}>
                    <Route path={R.CMS_DARTS} element={<EmptyPage />} />
                    <Route path={R.CMS_DARTS_GAMES} element={<DartsGamesCRUD />} />
                    <Route path={R.CMS_DARTS_PLAYERS} element={<DartsPlayersCRUD />} />
                    <Route path={R.CMS_DARTS_TOURNAMENT} element={<TournamentsCRUD />} />
                    <Route path={R.CMS_DARTS_COMPETITION} element={<CompetitionsCRUD />} />
                    <Route path={R.CMS_TABLE_TENNIS} element={<EmptyPage />} />
                    <Route path={R.CMS_SNOOKER} element={<EmptyPage />} />
                    <Route path={R.CMS_ACCESS} element={<EmptyPage />} />
                    <Route path={R.CMS_ACCESS_CLIENTS} element={<ClientsCRUD />} />
                    <Route path={R.CMS_ACCESS_USERS} element={<UsersCRUD />} />
                    <Route path={R.CMS_ACCESS_LISTENERS} element={<ListenersCRUD />} />
                    <Route path={R.CMS_ACCESS_ROLES} element={<RolesList />} />
                {/*    <Route path={`${path}/darts/service`} element={DartsService} />*/}
                {/*    <Route path={`${path}/darts/adc-games`} element={DartsAdcGamesTable} />*/}
                {/*    <Route path={`${path}/darts/shootout`} element={DartsShootOutGames} />*/}
                {/*    <Route path={`${path}/darts/groups`} element={DartsGroups} />*/}
                {/*    <Route path={`${path}/darts/weeks`} element={DartsWeeks} />*/}
                {/*    <Route path={`${path}/darts/tournaments`} element={DartsTournaments} />*/}
                {/*    <Route path={`${path}/darts/series`} element={DartsSeries} />*/}
                {/*    <Route path={`${path}/mss/news`} element={MssNewsTable} />*/}
                </Route>
                <Route path={R.BILLING_PLANS} element={<BillingPlans/>} />
                <Route path={R.BILLING_PAYNOW} element={<BillingPayNow/>} />
                <Route path={R.BILLING_INVOICES} element={<BillingInvoice/>} />
                <Route path={R.BILLING_RESULT} element={<BillingPaymentResult/>} />
                <Route path={R.SEND_EMAIL} element={<SendEmailForm />} />
                <Route path={R.ABOUT_DARTS} element={<AboutDarts />} />
                <Route path={R.DARTS_SCORING} element={<DartsScoring />}/>
                <Route path={R.STATISTICS} element={<Statistics />}/>
                <Route path={R.LOGGING_EXCEPTIONS} element={<LoggingExceptions />}/>
                <Route path={R.LOGGING_CONNECTIONS} element={<LoggingConnections />}/>
                <Route path={R.LOGGING_MESSAGES} element={<LoggingMessages />}/>
                <Route path={R.PRE_MATCH_ANIMATION} element={<PreMatchPage />}/>
                <Route path={R.PRE_MATCH_STATS_values} element={<StaticStatistic />}/>
                <Route path={R.POST_MATCH_values} element={<PostMatchPage />}/>
                <Route path={R.GAME_SCORES_DARTS} element={<GameScores />}/>
                <Route path={R.ACTIVE_GAME_SCORE_values} element={<ActiveGameScorePage />}/>
                <Route path={R.ACTIVE_GAME_SCORE_SHOOTOUT} element={<ShootOutActiveGameScorePage />}/>
                <Route path={R.DARTS_LEAGUES} element={<LeagueTablePage />}/>
                <Route path={R.MATCH_STATS_TABLE_values} element={<DartMatchStatsTable />}/>
                <Route path={R.MATCH_STATS_TABLE_SHOOTOUT} element={<ShootOutMatchStats />}/>
                <Route path={R.DAILY_RESULTS} element={<DailyResults />}/>
                <Route path={R.DENIED} element={<DeniedPage/>}/>
                <Route path={R.LOGIN} element={<Login/>}/>
                <Route path={R.REGISTRATION} element={<Registration />} />
                <Route path={R.PASSWORD} element={<Password/>}/>
                {/*<Route path='*' element={<Navigate to={R.LOGIN} />}/>*/}
                <Route path='*' element={<Login />} />
            </Routes>
            <ReduxToastr
                timeOut={5000}
                newestOnTop={false}
                preventDuplicates
                position="top-right"
                transitionIn="fadeIn"
                transitionOut="fadeOut"
                progressBar closeOnToastrClick
            />
        </Fragment>
    )
}

export default AppContainer;